import Preact, { Component, h } from 'preact'
import {isChangeEvent} from "../../libs/preact-entry";

interface Props {
  class: string,
  placeholder?: string,
  maxLength?: number | undefined,
  onContentChange?: (value: string) => void,
  onTextareaFocus?: () => void,
  value?: string | number,
  onInput?: () => void,
  error?: boolean,
  disabled?: boolean,
  newStyle?: boolean,
  verticalResize?: boolean
}
interface State {}

class Textarea extends Component<Props, State> {
  textareaElement = Preact.createRef()
  constructor (props: Props) {
    super(props)
    this.adjustHeight = this.adjustHeight.bind(this)
  }

  componentDidUpdate () {
    this.adjustHeight()
  }

  adjustHeight () {
    const el = this.textareaElement
    const outerHeight = parseInt(window.getComputedStyle(el).height, 10)
    const diff = outerHeight - el.clientHeight
    el.style.height = '48px'
    el.style.height = el.scrollHeight + diff + 'px'
  }

  render ({ class: customClass, placeholder, maxLength, onContentChange, onTextareaFocus, value, onInput, error, disabled = false, newStyle = false, verticalResize = false }: Props) {
    if (error) {
      customClass += ' error'
    }

    if (disabled) {
      customClass += ' disabled'
    }

    if (newStyle) {
      customClass += ' textarea-new'
    }

    if (verticalResize) {
      customClass += ' textarea-vertical'
    }

    return (
      <textarea
        className={customClass}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        onChange={(e) => {
          if (onContentChange && isChangeEvent(e)) {
            onContentChange((e.target as HTMLInputElement).value)
          }
        }}
        onClick={onTextareaFocus}
        value={value}
        onInput={() => this.adjustHeight()}
        ref={textarea => { this.textareaElement = textarea }}
      />
    )
  }
}

export default Textarea
